var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-assignment"},[_c('navbar'),_c('breadcrumbs'),_c('div',{staticClass:"container"},[_c('work-attentance')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }